module.exports = {
  topType: [
    { value: "NoHair", label: "Chauve" },
    { value: "Eyepatch", label: "Cache-oeil" },
    { value: "Hat", label: "Chapeau" },
    { value: "Hijab", label: "Hijab" },
    { value: "Turban", label: "Turban" },
    { value: "WinterHat1", label: "Bonnet 1" },
    { value: "WinterHat2", label: "Bonnet 2" },
    { value: "WinterHat3", label: "Bonnet 3" },
    { value: "WinterHat4", label: "Bonnet 4" },
    { value: "LongHairBigHair", label: "Cheveux longs et épais" },
    { value: "LongHairBob", label: "Carré" },
    { value: "LongHairBun", label: "Chignon" },
    { value: "LongHairCurly", label: "Cheveux longs frisés" },
    { value: "LongHairCurvy", label: "Cheveux longs bouclés" },
    { value: "LongHairDreads", label: "Cheveux longs dreads" },
    { value: "LongHairFrida", label: "Couronne de fleurs" },
    { value: "LongHairFro", label: "Cheveux longs afro" },
    { value: "LongHairFroBand", label: "Cheveux longs afro bandana" },
    { value: "LongHairNotTooLong", label: "Cheveux mi-longs" },
    { value: "LongHairShavedSides", label: "Cheveux longs et rasés sur les côtés" },
    { value: "LongHairMiaWallace", label: "Coupe carré frange" },
    { value: "LongHairStraight", label: "Cheveux longs lisse 1" },
    { value: "LongHairStraight2", label: "Cheveux longs lisse 2" },
    { value: "LongHairStraightStrand", label: "Cheveux longs lisse 3" },
    { value: "ShortHairDreads01", label: "Cheveux courts dreads 1" },
    { value: "ShortHairDreads02", label: "Cheveux courts dreads 2" },
    { value: "ShortHairFrizzle", label: "Cheveux courts et rasés sur les côtés" },
    { value: "ShortHairShaggyMullet", label: "Cheveux courts mulet" },
    { value: "ShortHairShortCurly", label: "Cheveux courts bouclés" },
    { value: "ShortHairShortFlat", label: "Cheveux courts et plats" },
    { value: "ShortHairShortRound", label: "Cheveux courts et ronds" },
    { value: "ShortHairShortWaved", label: "Cheveux courts et agités" },
    { value: "ShortHairSides", label: "Calvitie" },
    { value: "ShortHairTheCaesar", label: "Cheveux courts césar" },
    { value: "ShortHairTheCaesarSidePart", label: "Cheveux courts césar rasé" },
  ],
  accessoriesType: [
    { value: "Blank", label: "Pas d'accessoire" },
    { value: "Kurt", label: "Lunettes de soleil papillon" },
    { value: "Prescription01", label: "Lunettes de vue blanches" },
    { value: "Prescription02", label: "Lunettes de vue noires" },
    { value: "Round", label: "Lunettes rondes" },
    { value: "Sunglasses", label: "Lunettes de soleil" },
    { value: "Wayfarers", label: "Lunettes de soleil large" }
  ],
  hatColor: [
    { value: "Black", label: "Noir" },
    { value: "Blue01", label: "Bleu 1" },
    { value: "Blue02", label: "Bleu 2" },
    { value: "Blue03", label: "Bleu 3" },
    { value: "Gray01", label: "Gris 1" },
    { value: "Gray02", label: "Gris 2" },
    { value: "Heather", label: "Gris foncé" },
    { value: "PastelBlue", label: "Bleu clair" },
    { value: "PastelGreen", label: "Vert clair" },
    { value: "PastelOrange", label: "Orange clair" },
    { value: "PastelRed", label: "Rouge clair" },
    { value: "PastelYellow", label: "Jaune clair" },
    { value: "Pink", label: "Rose" },
    { value: "Red", label: "Rouge" },
    { value: "White", label: "Blanc" }
  ],
  hairColor: [
    { value: "Auburn", label: "Auburn" },
    { value: "Black", label: "Noir" },
    { value: "Blonde", label: "Blond" },
    { value: "BlondeGolden", label: "Blond platine" },
    { value: "Brown", label: "Brun" },
    { value: "BrownDark", label: "Brun foncé" },
    { value: "PastelPink", label: "Rose" },
    { value: "Platinum", label: "Argenté" },
    { value: "Red", label: "Rouge" },
    { value: "SilverGray", label: "Gris" }
  ],
  facialHairType: [
    { value: "Blank", label: "Sans pilosité" },
    { value: "BeardMedium", label: "Barbe moyenne" },
    { value: "BeardLight", label: "Barbe légère" },
    { value: "BeardMajestic", label: "Barbe majestueuse" },
    { value: "MoustacheFancy", label: "Moustache 1" },
    { value: "MoustacheMagnum", label: "Moustache 2" }
  ],
  facialHairColor: [
    { value: "Auburn", label: "Auburn" },
    { value: "Black", label: "Noir" },
    { value: "Blonde", label: "Blond" },
    { value: "BlondeGolden", label: "Blond platine" },
    { value: "Brown", label: "Brun" },
    { value: "BrownDark", label: "Brun foncé" },
    { value: "Platinum", label: "Argenté" },
    { value: "Red", label: "Rouge" }
  ],
  clotheType: [
    { value: "BlazerShirt", label: "Veste 1" },
    { value: "BlazerSweater", label: "Veste 2" },
    { value: "CollarSweater", label: "Pull et chemise" },
    { value: "GraphicShirt", label: "T-shirt à personnaliser" },
    { value: "Hoodie", label: "Sweat à capuche" },
    { value: "Overall", label: "Salopette" },
    { value: "ShirtCrewNeck", label: "Pull col rond" },
    { value: "ShirtScoopNeck", label: "Pull col évasé" },
    { value: "ShirtVNeck", label: "Pull col V" }
  ],
  clotheColor: [
    { value: "Black", label: "Noir" },
    { value: "Blue01", label: "Bleu 1" },
    { value: "Blue02", label: "Bleu 2" },
    { value: "Blue03", label: "Bleu 3" },
    { value: "Gray01", label: "Gris 1" },
    { value: "Gray02", label: "Gris 2" },
    { value: "Heather", label: "Gris foncé" },
    { value: "PastelBlue", label: "Bleu clair" },
    { value: "PastelGreen", label: "Vert clair" },
    { value: "PastelOrange", label: "Orange clair" },
    { value: "PastelRed", label: "Rouge clair" },
    { value: "PastelYellow", label: "Jaune clair" },
    { value: "Pink", label: "Rose" },
    { value: "Red", label: "Rouge" },
    { value: "White", label: "Blanc" }
  ],
  graphicType: [
    { value: "Bat", label: "Chauve-souris" },
    { value: "Cumbia", label: "Cumbia" },
    { value: "Deer", label: "Cerf" },
    { value: "Diamond", label: "Diamant" },
    { value: "Hola", label: "Hola !" },
    { value: "Pizza", label: "Pizza" },
    { value: "Resist", label: "Resist !" },
    { value: "Selena", label: "Selena" },
    { value: "Bear", label: "Ours" },
    { value: "SkullOutline", label: "Tête de mort 1" },
    { value: "Skull", label: "Tête de mort 2" }
  ],
  eyeType: [
    { value: "Close", label: "Fermé" },
    { value: "Cry", label: "Triste" },
    { value: "Default", label: "Par défaut" },
    { value: "Dizzy", label: "Croix" },
    { value: "EyeRoll", label: "Au ciel" },
    { value: "Happy", label: "Joyeux" },
    { value: "Hearts", label: "Amoureux" },
    { value: "Side", label: "Sur le côté" },
    { value: "Squint", label: "Plissé" },
    { value: "Surprised", label: "Surpris" },
    { value: "Wink", label: "Clin d'oeil 1" },
    { value: "WinkWacky", label: "Clin d'oeil 2" }
  ],
  eyebrowType: [
    { value: "Angry", label: "Enervé 1" },
    { value: "AngryNatural", label: "Enervé 2" },
    { value: "Default", label: "Par défaut" },
    { value: "DefaultNatural", label: "Naturel" },
    { value: "FlatNatural", label: "Droit" },
    { value: "RaisedExcited", label: "Etonné 1" },
    { value: "RaisedExcitedNatural", label: "Etonné 2" },
    { value: "SadConcerned", label: "Triste 1" },
    { value: "SadConcernedNatural", label: "Triste 2" },
    { value: "UnibrowNatural", label: "Monosourcil" },
    { value: "UpDown", label: "Décalé 1" },
    { value: "UpDownNatural", label: "Décalé 2" }
  ],
  mouthType: [
    { value: "Concerned", label: "Choqué 1" },
    { value: "Default", label: "Par défaut" },
    { value: "Disbelief", label: "Choqué 2" },
    { value: "Eating", label: "Miam" },
    { value: "Grimace", label: "Grimace" },
    { value: "Sad", label: "Triste" },
    { value: "ScreamOpen", label: "Cri" },
    { value: "Serious", label: "Sérieux" },
    { value: "Smile", label: "Grand sourire" },
    { value: "Tongue", label: "Langue" },
    { value: "Twinkle", label: "Petit sourire" },
    { value: "Vomit", label: "Vomis" }
  ],
  skinColor: [
    { value: "Tanned", label: "Bronzé" },
    { value: "Yellow", label: "Jaune" },
    { value: "Pale", label: "Pâle" },
    { value: "Light", label: "Clair" },
    { value: "Brown", label: "Marron" },
    { value: "DarkBrown", label: "Marron foncé" },
    { value: "Black", label: "Noir" }
  ]
}
